import ListSubheader from '@liquidweb-dev/undercurrent/ListSubheader';
import MenuItem from '@liquidweb-dev/undercurrent/MenuItem';
import type { TextFieldProps } from '@liquidweb-dev/undercurrent/TextField';
import Typography from '@liquidweb-dev/undercurrent/Typography';

import HookedTextField from 'components/standard/Form/HookedTextField';
import useAssetCancellationReasonList from 'modules/queries/asset/cancellation/useReasonList';

const ReasonList = (props: TextFieldProps) => {
	const { isLoading: isReasonsLoading, data: cancellationReasons } =
		useAssetCancellationReasonList();

	return (
		<HookedTextField
			name="cancellation_reason"
			label="Reason for cancellation"
			size="large"
			fullWidth
			select
			disabled={isReasonsLoading}
			slotProps={{
				select: {
					displayEmpty: true,
				},
			}}
			{...props}
		>
			<MenuItem value="" disabled sx={{ display: 'none' }}>
				Select a reason
			</MenuItem>
			{cancellationReasons?.map((data) => {
				if (data.type === 'category') {
					return (
						<ListSubheader
							sx={{
								backgroundColor: 'transparent',
								paddingX: 200,
								paddingY: 50,
							}}
							key={data.label}
						>
							<Typography fontWeight={500} variant="label-xl">
								{data.label}
							</Typography>
						</ListSubheader>
					);
				}

				return (
					<MenuItem key={data.label} value={data.label}>
						<Typography
							fontWeight={400}
							variant="label-xl"
							lineHeight="24px"
							whiteSpace="normal"
						>
							{data.label}
						</Typography>
					</MenuItem>
				);
			})}
		</HookedTextField>
	);
};

export default ReasonList;
